$(document).ready(function() {  
// Call Flexslider globally
  
   $('#mainslider').flexslider({
     animation: "fade",
     controlNav: false,
     slideshowSpeed: 4000,
     directionNav: true
   });

  function resizeHomepage() {

   var contentwidth = $('.slides').width();
     if(!contentwidth) return;
    
    if($('#js-swap-image1').length > 0){
      if ((contentwidth) < '710'){
          $('#js-swap-image1').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide1_mobile.jpg?v=65110326300985315391444505045');
      } 
      else {
        $('#js-swap-image1').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide1.jpg?v=16359845739357516141444505045');
      }
    }
                                 
    if($('#js-swap-image2').length > 0){
      if ((contentwidth) < '710'){
          $('#js-swap-image2').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide2_mobile.jpg?v=184315763187383019441444505045');
      } 
      else {
        $('#js-swap-image2').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide2.jpg?v=173226598283660487881444505045');
      }
    }
                                  
    if($('#js-swap-image3').length > 0){
      if ((contentwidth) < '710'){
          $('#js-swap-image3').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide3_mobile.jpg?v=124961915567115687101444505045');
      } 
      else {
        $('#js-swap-image3').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide3.jpg?v=61975122991990186821444505045');
      }
    }
                                  
    if($('#js-swap-image4').length > 0){
      if ((contentwidth) < '710'){
          $('#js-swap-image4').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide4_mobile.jpg?v=172107397754430028091444505045');
      } 
      else {
        $('#js-swap-image4').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide4.jpg?v=50377150280119836301444505045');
      }
    }
                                  
    if($('#js-swap-image5').length > 0){
      if ((contentwidth) < '710'){
          $('#js-swap-image5').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide5_mobile.jpg?v=122465622657831964991444505046');
      } 
      else {
        $('#js-swap-image5').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/slide5.jpg?v=181004060784577711741444505045');
      }
    }
                                     
   }

   function resizeAbout() {                          
   	 var contentwidth = $('.about').width();
     if(!contentwidth) return;
     if ((contentwidth) < '710'){
       $('.js-swap-image').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/about_mobile.jpg?v=83019785715868005291444505039');
     } else {
       $('.js-swap-image').attr('src','//cdn.shopify.com/s/files/1/0864/9950/t/2/assets/about.jpg?v=13971972600263028631444505039');
     }
   }
    
   $(".flexnav").flexNav();
                                
   resizeHomepage();//Activates when document first loads 
   resizeAbout();
   $(window).bind("resize", function(){
   	resizeHomepage();
    resizeAbout();
   });

});